export const MEDIA_QUERY = {
  mobile: "(max-width: 1024px)",
  handset: "(max-width: 640px)",
} as const;
